<template>
    <div class="edit-note-form-container page-content popup-shadow">
        <!--    notes    -->
        <div class="tab-header-container">
            <h2 class="form-label">{{getTitle}}</h2>
            <LiteButton @click.native="close"
                        style="font-size: 35px; float: right;"
                        class="edit-button"
                        :hoverColor="'red'"
                        :icon="'far fa-window-close'">
            </LiteButton>
        </div>

        <hr class="form-line">

        <div class="form-container-note">
            <p class="note-content-label">Съдържание:</p>
            <textarea class="note-content-text-area" v-model="currentNote.content">
            </textarea>
        </div>

            <Button class="save-button"
                    @click.native="saveForm"
                    :color="'green'"
                    :text="'Запази'"
                    :icon="'fa fa-save'"></Button>

            <Button class="save-button"
                    style="margin-top: 60px;"
                    v-if="this.currentNote.id"
                    @click.native="showDeleteConfirm = true"
                    :color="'red'"
                    :text="'Изтрий'"
                    :icon="'fa fa-trash-alt'"></Button>

            <div id="confirmDeleteNote" class="delete-note-confirm" v-if="showDeleteConfirm">
                <p>Сигурне ли сте?</p>
                <Button class="delete-note-button-confirm" @click.native="deleteNote" :id="'yes'" :text="'Да'"></Button>
                <Button class="delete-note-button-confirm" @click.native="showDeleteConfirm = false" :id="'no'" :text="'Не'"></Button>
            </div>
    </div>
</template>

<script>
    import Button from "@/shared/components/button/Button";
    import LiteButton from "@/shared/components/button/LiteButton";
    import workerService from "@/services/worker.service";
    import {cloneDeep} from 'lodash';

    export default {
        name: "WorkerNotesEditForm",
        components: {LiteButton, Button},
        props: {
          note: Object
        },
        data() {
            return {
                currentNote: cloneDeep(this.note),
                showDeleteConfirm: false
            }
        },
        methods: {
            setContent(value) {
                this.currentNote.content = value;
            },
            saveForm() {
                workerService.addOrEditNote(this.currentNote)
                    .then(({data}) => {
                        this.$store.commit('setWorkerNotes', data);
                        this.$emit('close-clicked', {});
                    })
                    .catch(() => this.$emit('close-clicked', {}));
            },
            deleteNote() {
                workerService.deleteNote(this.currentNote.id)
                    .then(({data}) => {
                        this.$store.commit('setWorkerNotes', data);
                        this.$emit('close-clicked', {});
                    })
                    .catch(() => this.$emit('close-clicked', {}));
            },
            close() {
                this.$emit('close-clicked', {});
            }
        },
        computed: {
            getTitle() {
                return this.currentNote.id ? 'Редактиране на бележка' : 'Добавяне на бележка';
            }
        }
    }
</script>

<style scoped>
@import '../../../css/main/notes.css';
</style>
